import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Dropdown, Tab } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import Select, { StylesConfig } from 'react-select';
import { getDataAccountPreferenceFormAsync, UpdateAccountPreferencesAsync, updateLoadingEffect, uploadLogo } from "./accountPreferenceSlice";
import fetchAPI from '../../../common/fetchAPI';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { AccountPreferenceInitialsForAdd, AccountPreferenceInitialsForUpdate } from "./interfaces/accountPreferenceClass";
import '../../../common/css/timeLive.css'
import { useDropzone } from "react-dropzone";
import { ShowToast } from "../../../common/Toastr";
import { ShowSwal } from '../../../common/SweetAlert';
import { determineCultureFormat, dropDownSelectionStyles, getDateFormatPatternByCulture, getDecimalSeparator, getValueFromResource } from '../../../common/timeLiveFunction';
import { updatePageIdState, getPagePermissionsAsync, updatePageSize, updateAllowZeroHoursInTimesheet, getCustomPagePermissionsAsync, getGlobalAccountPreferenceDataAsync } from '../../../common/GlobalSlice';
import Loader from "../../../common/Loader";
import moment from "moment";
import 'react-time-picker/dist/TimePicker.css';
import TimePicker from "react-time-picker";
import { Tooltip } from "react-tooltip";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";

const objErrorValues = {
    isError: false,
    errorMessageList: []
}

const initialValueForPermission = {
    IsMyTimesheet: false,// 18 
    IsTimeEntryPeriodView: false,// 19
    IsBilling: false, //134
    IsMyExpenses: false,// 135 
    IsMyTimeOff: false,// 142
}

const AccountPreference = () => {
    const dispatch = useAppDispatch();
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(AccountPreferenceInitialsForAdd);
    const { t } = useTranslation();
    const { accountPreferenceDetail, isReload, selectedRecord, isLoading, applicationMode } = useAppSelector((state) => state.accountPreferences);
    const [tab, setTab] = useState('Organization');
    const [selectedOptionCountry, setselectedOptionCountry] = useState<{ [object: string]: any }>();
    const [countryArray, SetCountryArray] = useState<any | ''>([]);
    const [selectedOptionTimeZone, setselectedOptionTimeZone] = useState<{ [object: string]: any }>();
    const [TimeZoneArray, SetTimeZoneArray] = useState<any | ''>([]);
    const [selectedOptionStandardFormat, setselectedOptionStandardFormat] = useState<{ [object: string]: any }>();
    const [StandardFormatArray, SetStandardFormatArray] = useState<any | ''>([]);
    const [selectedOptionBillingType, setselectedOptionBillingType] = useState<{ [object: string]: any }>();
    const [BillingTypeArray, SetBillingTypeArray] = useState<any | ''>([]);
    const [selectedOptionTimeEntryHoursFormat, setselectedOptionTimeEntryHoursFormat] = useState<{ [object: string]: any }>();
    const [TimeEntryHoursFormatArray, SetTimeEntryHoursFormatArray] = useState<any | ''>([]);
    const [dateFormateLabel, setDateFormateLabel] = useState('');
    const [decimalSeparatorLabel, setdecimalSeparator] = useState('');
    const EmailSubscription = false;
    const [inputValue, setInputValue] = useState('');
    const [scheduledEmailSendTime, setScheduledEmailSendTime] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [files, setFiles]: any = useState([]);
    const [childs, setChilds] = useState(initialValueForPermission);
    const [setError, setErrorValues] = useState<any | ''>(objErrorValues);
    const { pageId, menuList, IsEdit, maxMenuHeight, sessionAccountId, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    const navigate = useNavigate();

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: acceptedFiles => {
            const formData = new FormData();
            acceptedFiles.forEach((file: any, index: any) => {
                formData.append('files' + index, file);
            });
            let param: any = {};
            param = { formData: formData }
            dispatch(uploadLogo(param))
                .then(response => {
                })
            setFiles(acceptedFiles.map((file: any) => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
        },
        accept: {
            "image/*": [".png", ".gif", ".jpeg", ".jpg"],
        },
        maxSize: 31457280
    });

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                // if (!res.payload.IsList) {
                //     navigate('../error/403');
                // }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    // if (!res.payload.IsList) {
                    //     navigate('../error/403');
                    // }
                } else {
                    //navigate('../error/403');
                }
            }
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const [selectedOptionDecimal, setSelectedOptionDecimal] = useState<any | ''>([]);
    const options = [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 }
    ];

    const [selectedOptionPageSize, setSelectedOptionPageSize] = useState<any | ''>([]);
    const PageOptions = [
        { label: '10', value: 10 },
        { label: '20', value: 20 },
        { label: '30', value: 30 },
        { label: '40', value: 40 },
        { label: '50', value: 50 },
    ];

    const [selectedOptionShowEmployeeNameBy, setSelectedOptionShowEmployeeNameBy] = useState<any | ''>([]);
    const ShowEmployeeNameByOptions = [
        { label: (t('First Name And Last Name')), value: 1 },
        { label: (t('Last Name And First Name')), value: 2 },
    ];

    const [selectedOptionEmployeeSegregationType, setSelectedOptionEmployeeSegregationType] = useState<any | ''>([]);
    const EmployeeSegregationTypeOptions = [
        { label: 'None', value: 0 },
        { label: 'Department', value: 1 },
        { label: 'Location', value: 2 },
    ];

    const [selectedOptionSortTaskBy, setSelectedOptionSortTaskBy] = useState<any | ''>([]);
    const SortTaskByOptions = [
        { label: 'Task Id', value: 'TaskId' },
        { label: 'Deadline Date', value: 'DeadlineDate' },
    ];

    const [selectedOptionShowAdditionalProjectInformationType, setSelectedOptionShowAdditionalProjectInformationType] = useState<any | ''>([]);
    const ShowAdditionalProjectInformationTypeOptions = [
        { label: 'None', value: 0 },
        { label: 'Project Code', value: 1 },
    ];

    const [selectedOptionShowTimeOffTypesBy, setSelectedOptionShowTimeOffTypesBy] = useState<any | ''>([]);
    const ShowTimeOffTypesByOptions = [
        { label: 'Account', value: 'Account' },
        { label: 'Employee', value: 'Employee' },
    ];

    const [selectedOptionExpenseApprovalTypeBy, setSelectedOptionExpenseApprovalTypeBy] = useState<any | ''>([]);
    const ExpenseApprovalTypeByOptions = [
        { label: 'Project', value: 'Project' },
        { label: 'Employee', value: 'Employee' },
    ];

    const [selectedOptionShowClockStartEndBy, setSelectedOptionShowClockStartEndBy] = useState<any | ''>([]);
    const ShowClockStartEndByOptions = [
        { label: 'Account', value: 'Account' },
        { label: 'Working Day', value: 'Employee' },
    ];

    const [selectedOptionTimeEntryClockFormat, setSelectedOptionTimeEntryClockFormat] = useState<any | ''>([]);
    const TimeEntryClockFormatOptions = [
        { label: 'HH:MM', value: 'HH:mm' },
        { label: 'HH:MM AM/PM', value: 'hh:mm tt' },
    ];

    const [selectedOptionShowAdditionalTaskInformationTypeInTimesheet, setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet] = useState<any | ''>([]);
    const ShowAdditionalTaskInformationTypeInTimesheetOptions = [
        { label: 'None', value: 0 },
        { label: 'Parent Task Name', value: 1 },
        { label: 'Parent Task Code', value: 2 },
        { label: 'Task Code', value: 3 },
        { label: 'Task Type', value: 4 },
        { label: 'All Parent Task Name', value: 5 },
    ];

    const [selectedOptionDefaultTimeEntryMode, setSelectedOptionDefaultTimeEntryMode] = useState<any | ''>([]);
    const DefaultTimeEntryModeOptions = [
        // { label: 'Day View', value: 'Day View' },
        { label: 'Period View', value: 'Period View' },
    ];

    const [selectedOptionSortTimesheetBy, setSelectedOptionSortTimesheetBy] = useState<any | ''>([]);
    const SortTimesheetByOptions = [
        { label: 'Default', value: 'Default' },
        { label: 'Client', value: 'Client' },
        { label: 'Project', value: 'Project' },
        { label: 'Task', value: 'Task' },
        { label: 'ProjectTask', value: 'ProjectTask' }
    ];

    const [selectedOptionShowCostCenterInTimesheetBy, setSelectedOptionShowCostCenterInTimesheetBy] = useState<any | ''>([]);
    const ShowCostCenterInTimesheetByOptions = [
        { label: 'Account', value: 'Account' },
        { label: 'Employee', value: 'Employee' },
        { label: 'Task', value: 'Task' },
    ];

    const [selectedOptionTimesheetApprovalTypeBy, setSelectedOptionTimesheetApprovalTypeBy] = useState<any | ''>([]);
    const TimesheetApprovalTypeByOptions = [
        { label: 'Project', value: 'Project' },
        // { label: 'Employee', value: 'Employee' },

    ];
    const CalendarWeekStartDayOptions = [
        { label: 'None', value: 'None' },
        { label: 'Monday', value: 'MON' },
        { label: 'Tuesday', value: 'TUE' },
        { label: 'Wednesday', value: 'WED' },
        { label: 'Thursday', value: 'THU' },
        { label: 'Friday', value: 'FRI' },
        { label: 'Saturday', value: 'SAT' },
        { label: 'Sunday', value: 'SUN' }
    ];
    const [selectedOptionCalendarWeekStartDay, setSelectedOptionCalendarWeekStartDay] = useState<any>(CalendarWeekStartDayOptions[0]);

    const [selectedOptionSingleSignOnSSO, setSelectedOptionSingleSignOnSSO] = useState<any | ''>([]);
    const SingleSignOnSSOOptions = [
        { label: 'ADFS', value: 'ADFS' },
        { label: 'SAML', value: 'SAML' },

    ];

    const [selectedOptionAssignHolidayTypeIn, setSelectedOptionAssignHolidayTypeIn] = useState<any | ''>([]);
    const AssignHolidayTypeInOptions = [
        { label: 'Employee', value: '1' },
        { label: 'Location', value: '2' },

    ];

    const [selectedOptionAssignWorkingDayTypeIn, setSelectedOptionAssignWorkingDayTypeIn] = useState<any | ''>([]);
    const AssignWorkingDayTypeInOptions = [
        { label: 'Employee', value: '1' },
        { label: 'Department', value: '2' },

    ];

    const [selectedOptionAssignTimeOffPolicyIn, setSelectedOptionAssignTimeOffPolicyIn] = useState<any | ''>([]);
    const AssignTimeOffPolicyInOptions = [
        { label: 'Employee', value: '1' },
        { label: 'Department', value: '2' },

    ];




    useEffect(() => {
        if (isReload) {
            dispatch(getDataAccountPreferenceFormAsync());

        }
    }, [isReload])

    useEffect(() => {
        renderPreferenceFields().then((result) => {
            dispatch(getDataAccountPreferenceFormAsync());
        }).catch((error) => {

        });
    }, []);

    useEffect(() => {
        if (setError.errorMessageList.length > 0) {
            setErrorValues((prevState: any) => ({
                ...prevState,
                isError: true
            }));
        } else {
            setErrorValues((prevState: any) => ({
                ...prevState,
                isError: false
            }));
        }
    }, [setError.errorMessageList]);

    const renderPreferenceFields = async () => {
        const response = await fetchAPI(`api/V2/AccountPreferences/AllDataInSingleRequest`, 'Get', '', true);
        const json = await response.json();
        json["Countries"].map((item: any) => {
            item.value = item.CountryId;
            item.label = item.Country;
            delete item.CountryId;
            delete item.Country;
        });
        SetCountryArray(json["Countries"]);
        json["TimeZones"].map((item: any) => {
            item.value = item.SystemTimeZoneId;
            item.label = item.TimeZoneName;
            delete item.SystemTimeZoneId;
            delete item.TimeZone;
        });
        SetTimeZoneArray(json["TimeZones"]);
        json["StandardAndFormats"].map((item: any) => {
            item.value = item.Name;
            item.label = item.EnglishName;
            delete item.Name;
            delete item.EnglishName;
        });
        SetStandardFormatArray(json["StandardAndFormats"]);
        json["InvoiceBillingType"].map((item: any) => {
            item.value = item.InvoiceBillingTypeId;
            item.label = item.InvoiceBillingType;
            delete item.InvoiceBillingTypeId;
            delete item.InvoiceBillingType;
        });
        SetBillingTypeArray(json["InvoiceBillingType"]);
        json["SystemTimeEntryHoursFormat"]?.filter((item: any) => item.SystemTimeEntryHoursFormat !== 'Percent')?.map((item: any) => {
            item.value = item.SystemTimeEntryHoursFormatId;
            item.label = item.SystemTimeEntryHoursFormat;
            delete item.SystemTimeEntryHoursFormatId;
            delete item.SystemTimeEntryHoursFormat;
        });
        SetTimeEntryHoursFormatArray(json["SystemTimeEntryHoursFormat"]);
    }


    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            setCurrentFieldsData(selectedRecord);
            Object.keys(AccountPreferenceInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            setselectedOptionCountry({ value: tempObj.CountryId, label: tempObj.Country });
            setselectedOptionTimeZone({ value: tempObj.TimeZoneId, label: tempObj.TimeZoneName });
            setSelectedOptionDecimal({ value: tempObj.DecimalPlaces, label: tempObj.DecimalPlaces });
            setSelectedOptionPageSize({ value: tempObj.PageSize, label: tempObj.PageSize });
            setselectedOptionStandardFormat({ value: tempObj.CultureInfoName, label: tempObj.EnglishName });
            setselectedOptionTimeEntryHoursFormat({ value: tempObj.TimeEntryHoursFormatId, label: tempObj.SystemTimeEntryHoursFormat });
            setDateFormateLabel(getDateFormatPatternByCulture(tempObj.CultureInfoName));
            setdecimalSeparator(getDecimalSeparator(tempObj.CultureInfoName));
            if (tempObj.InvoiceBillingTypeId === 'f06cbf01-a190-4424-bfa9-0e8d58812952') {
                setselectedOptionBillingType({ value: stateItem.InvoiceBillingTypeId, label: 'Hours' });
            }
            else {
                setselectedOptionBillingType({ value: stateItem.InvoiceBillingTypeId, label: 'Days' });
            }
            setSelectedOptionSortTimesheetBy({ value: stateItem.TimesheetSort, label: tempObj.TimesheetSort });
        }
        if (stateItem.ScheduledEmailSendTime) {
            // setScheduledEmailSendTime(moment(stateItem.ScheduledEmailSendTime).format('HH:mm'));
            setScheduledEmailSendTime(stateItem.ScheduledEmailSendTime.split('T')[1].substring(0, 5));
        } else {
            setScheduledEmailSendTime("00:00");
        }
        if (stateItem.ShowEmployeeNameBy === 1) {
            setSelectedOptionShowEmployeeNameBy({ value: stateItem.ShowEmployeeNameBy, label: 'First Name And Last Name' });
        } else {
            setSelectedOptionShowEmployeeNameBy({ value: stateItem.ShowEmployeeNameBy, label: 'Last Name And First Name' });
        }
        if (stateItem.EmployeeSegregationType === 0) {
            setSelectedOptionEmployeeSegregationType({ value: stateItem.EmployeeSegregationType, label: 'None' });
        } else if (stateItem.EmployeeSegregationType === 1) {
            setSelectedOptionEmployeeSegregationType({ value: stateItem.EmployeeSegregationType, label: 'Department' });
        }
        else if (stateItem.EmployeeSegregationType === 2) {
            setSelectedOptionEmployeeSegregationType({ value: stateItem.EmployeeSegregationType, label: 'Location' });
        }
        if (stateItem.SortTaskBy === "TaskId") {
            setSelectedOptionSortTaskBy({ value: stateItem.SortTaskBy, label: 'Task ld' });
        }
        else {
            setSelectedOptionSortTaskBy({ value: stateItem.SortTaskBy, label: 'Deadline Date' });
        }
        if (stateItem.ShowAdditionalProjectInformationType === 0) {
            setSelectedOptionShowAdditionalProjectInformationType({ value: stateItem.ShowAdditionalProjectInformationType, label: 'None' });
        }
        else {
            setSelectedOptionShowAdditionalProjectInformationType({ value: stateItem.ShowAdditionalProjectInformationType, label: 'Project Code' });
        }
        if (stateItem.ShowTimeOffTypesBy === "Account") {
            setSelectedOptionShowTimeOffTypesBy({ value: stateItem.ShowTimeOffTypesBy, label: 'Account' });
        }
        else {
            setSelectedOptionShowTimeOffTypesBy({ value: stateItem.ShowTimeOffTypesBy, label: 'Employee' });
        }
        if (stateItem.ExpenseApprovalTypeBy === "Project") {
            setSelectedOptionExpenseApprovalTypeBy({ value: stateItem.ExpenseApprovalTypeBy, label: 'Project' });
        }
        else {
            setSelectedOptionExpenseApprovalTypeBy({ value: stateItem.ExpenseApprovalTypeBy, label: 'Employee' });
        }
        if (stateItem.ShowClockStartEndBy === "Account") { setSelectedOptionShowClockStartEndBy({ value: stateItem.ShowClockStartEndBy, label: 'Account' }); }
        else { setSelectedOptionShowClockStartEndBy({ value: stateItem.ShowClockStartEndBy, label: 'Employee' }); }
        if (stateItem.TimeEntryFormat === "HH:mm") { setSelectedOptionTimeEntryClockFormat({ value: stateItem.TimeEntryFormat, label: 'HH:MM' }); }
        else { setSelectedOptionTimeEntryClockFormat({ value: stateItem.TimeEntryFormat, label: 'HH:MM AM/PM' }); }
        if (stateItem.ShowAdditionalTaskInformationType === 0) { setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: stateItem.ShowAdditionalTaskInformationType, label: 'None' }); }
        else
            if (stateItem.ShowAdditionalTaskInformationType === 1) { setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: stateItem.ShowAdditionalTaskInformationType, label: 'Parent Task Name' }); }
            else
                if (stateItem.ShowAdditionalTaskInformationType === 2) { setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: stateItem.ShowAdditionalTaskInformationType, label: 'Parent Task Code' }); }
                else
                    if (stateItem.ShowAdditionalTaskInformationType === 3) { setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: stateItem.ShowAdditionalTaskInformationType, label: 'Task Code' }); }
                    else
                        if (stateItem.ShowAdditionalTaskInformationType === 4) { setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: stateItem.ShowAdditionalTaskInformationType, label: 'Task Type' }); }
                        else
                            if (stateItem.ShowAdditionalTaskInformationType === 4) { setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: stateItem.ShowAdditionalTaskInformationType, label: 'All Parent Task Name' }); }

        if (stateItem.DefaultTimeEntryMode === "Day View") { setSelectedOptionDefaultTimeEntryMode({ value: stateItem.DefaultTimeEntryMode, label: 'Day View' }); }
        else { setSelectedOptionDefaultTimeEntryMode({ value: stateItem.DefaultTimeEntryMode, label: 'Period View' }); }

        // if (stateItem.TimesheetSort === "Default") { setSelectedOptionSortTimesheetBy({ value: stateItem.TimesheetSort, label: 'Default' }); }
        // else { setSelectedOptionSortTimesheetBy({ value: stateItem.TimesheetSort, label: 'Client' }); }

        if (stateItem.ShowCostCenterInTimesheetBy === "Account") { setSelectedOptionShowCostCenterInTimesheetBy({ value: stateItem.ShowCostCenterInTimesheetBy, label: 'Account' }); }
        else
            if (stateItem.ShowCostCenterInTimesheetBy === "Employee") { setSelectedOptionShowCostCenterInTimesheetBy({ value: stateItem.ShowCostCenterInTimesheetBy, label: 'Employee' }); }
            else
                if (stateItem.ShowCostCenterInTimesheetBy === "Task") { setSelectedOptionShowCostCenterInTimesheetBy({ value: stateItem.ShowCostCenterInTimesheetBy, label: 'Task' }); }


        if (stateItem.TimesheetApprovalTypeBy === "Project") { setSelectedOptionTimesheetApprovalTypeBy({ value: stateItem.TimesheetApprovalTypeBy, label: 'Project' }); }
        else { setSelectedOptionTimesheetApprovalTypeBy({ value: stateItem.TimesheetApprovalTypeBy, label: 'Employee' }); }

        if (stateItem.UsingSingleSignOnWith === "ADFS") { setSelectedOptionSingleSignOnSSO({ value: stateItem.UsingSingleSignOnWith, label: 'ADFS' }); }
        else { setSelectedOptionSingleSignOnSSO({ value: stateItem.UsingSingleSignOnWith, label: 'SAML' }); }


        if (stateItem.AssignHolidayTypeIn === 1) {
            setSelectedOptionAssignHolidayTypeIn({ value: stateItem.AssignHolidayTypeIn, label: 'Employee' });
        }
        else {
            setSelectedOptionAssignHolidayTypeIn({ value: stateItem.AssignHolidayTypeIn, label: 'Location' });
        }

        if (stateItem.AssignWorkingDayTypeIn === 1) {
            setSelectedOptionAssignWorkingDayTypeIn({ value: stateItem.AssignWorkingDayTypeIn, label: 'Employee' });
        }
        else {
            setSelectedOptionAssignWorkingDayTypeIn({ value: stateItem.AssignWorkingDayTypeIn, label: 'Department' });
        }

        if (stateItem.AssignTimeOffPolicyIn === 1) {
            setSelectedOptionAssignTimeOffPolicyIn({ value: stateItem.AssignTimeOffPolicyIn, label: 'Employee' });
        }
        else {
            setSelectedOptionAssignTimeOffPolicyIn({ value: stateItem.AssignTimeOffPolicyIn, label: 'Department' });
        }
        stateItem.IsEmailSubscription = stateItem.IsEmailSubscription === true ? true : false;
        // --General Information
        stateItem.LockSubmittedRecords = stateItem.LockSubmittedRecords === true ? true : false;
        stateItem.LockApprovedRecords = stateItem.LockApprovedRecords === true ? true : false;
        stateItem.IsShowElectronicSign = stateItem.IsShowElectronicSign === true ? true : false;
        stateItem.EnableUploadFeature = stateItem.EnableUploadFeature === true ? true : false;
        stateItem.ShowAdditionalDepartmentInformationInEmployee = stateItem.ShowAdditionalDepartmentInformationInEmployee === true ? true : false;
        stateItem.IsShowEmployeeNameWithCode = stateItem.IsShowEmployeeNameWithCode === true ? true : false;
        stateItem.IsShowDisableEmployeesInReport = stateItem.IsShowDisableEmployeesInReport === true ? true : false;
        stateItem.RestrictEntryWithinTaskDateRange = stateItem.RestrictEntryWithinTaskDateRange === true ? true : false;
        stateItem.IsCompanyOwnLogo = stateItem.IsCompanyOwnLogo === true ? true : false;
        // --Invoice
        stateItem.ShowProjectNameInInvoiceReport = stateItem.ShowProjectNameInInvoiceReport === true ? true : false;
        stateItem.ShowBillingRateInInvoiceReport = stateItem.ShowBillingRateInInvoiceReport === true ? true : false;
        stateItem.ShowEntryDateInInvoiceReport = stateItem.ShowEntryDateInInvoiceReport === true ? true : false;
        stateItem.ShowEmployeeNameInInvoiceReport = stateItem.ShowEmployeeNameInInvoiceReport === true ? true : false;
        stateItem.ShowWorkTypeInInvoiceDescription = stateItem.ShowWorkTypeInInvoiceDescription === true ? true : false;
        stateItem.RoundOffValueInInvoice = stateItem.RoundOffValueInInvoice === true ? true : false;
        stateItem.ResetInvoiceNo = stateItem.ResetInvoiceNo === true ? true : false;
        // --Task
        stateItem.ShowProjectNameInTask = stateItem.ShowProjectNameInTask === true ? true : false;
        stateItem.ShowClientNameInTask = stateItem.ShowClientNameInTask === true ? true : false;
        stateItem.IsAutoCompleteTask = stateItem.IsAutoCompleteTask === true ? true : false;
        stateItem.AllocationHoursInProjectTaskTeam = stateItem.AllocationHoursInProjectTaskTeam === true ? true : false;
        // --Project
        stateItem.AutoGenerateProjectCode = stateItem.AutoGenerateProjectCode === true ? true : false;
        stateItem.AllocationHoursInProjectTeam = stateItem.AllocationHoursInProjectTeam === true ? true : false;
        stateItem.EnableGanttChart = stateItem.EnableGanttChart === true ? true : false;
        stateItem.ShowCompletedProjectInProjectGrid = stateItem.ShowCompletedProjectInProjectGrid === true ? true : false;
        stateItem.ShowClientDepartmentInProject = stateItem.ShowClientDepartmentInProject === true ? true : false;
        stateItem.IncludeCurrentYearInProjectCode = stateItem.IncludeCurrentYearInProjectCode === true ? true : false;
        stateItem.AutomaticallyIncludeAdminitratorInProjectTeam = stateItem.AutomaticallyIncludeAdminitratorInProjectTeam === true ? true : false;
        stateItem.ShowClientDepartmentInProject = stateItem.ShowClientDepartmentInProject === true ? true : false;
        stateItem.ShowDisableProjectInReport = stateItem.ShowDisableProjectInReport === true ? true : false;
        stateItem.IsProjectTemplateMandatory = stateItem.IsProjectTemplateMandatory === true ? true : false;
        // --Time Off
        stateItem.ShowTimeOffInTimesheet = stateItem.ShowTimeOffInTimesheet === true ? true : false;
        stateItem.ShowProjectForTimeOff = stateItem.ShowProjectForTimeOff === true ? true : false;
        stateItem.HideTimeOffHoursInformation = stateItem.HideTimeOffHoursInformation === true ? true : false;
        stateItem.IsShowTimeOffInDays = stateItem.IsShowTimeOffInDays === true ? true : false;
        stateItem.IsShowTimeOffPoliciesInDays = stateItem.IsShowTimeOffPoliciesInDays === true ? true : false;
        stateItem.IsTimeOffStatusEditMode = stateItem.IsTimeOffStatusEditMode === true ? true : false;
        // --Expense Sheet
        stateItem.ShowClientInExpenseSheet = stateItem.ShowClientInExpenseSheet === true ? true : false;
        stateItem.ShowTaskInExpenseSheet = stateItem.ShowTaskInExpenseSheet === true ? true : false;
        // --Time Sheet
        stateItem.ShowClockStartEnd = stateItem.ShowClockStartEnd === true ? true : false;
        stateItem.ShowClientInTimesheet = stateItem.ShowClientInTimesheet === true ? true : false;
        stateItem.IsAllowOverlappingTimeEntries = stateItem.IsAllowOverlappingTimeEntries === true ? true : false;
        stateItem.ShowDescriptionInWeekView = stateItem.ShowDescriptionInWeekView === true ? true : false;
        stateItem.IsTimeEntryDescriptionRequired = stateItem.IsTimeEntryDescriptionRequired === true ? true : false;
        stateItem.ShowCompletedProjectsInTimeSheet = stateItem.ShowCompletedProjectsInTimeSheet === true ? true : false;
        stateItem.ShowCompletedTasksInTimeSheet = stateItem.ShowCompletedTasksInTimeSheet === true ? true : false;
        stateItem.ShowWorkTypeInTimeSheet = stateItem.ShowWorkTypeInTimeSheet === true ? true : false;
        stateItem.ShowCostCenterInTimeSheet = stateItem.ShowCostCenterInTimeSheet === true ? true : false;
        stateItem.ShowCopyTimesheetButton = stateItem.ShowCopyTimesheetButton === true ? true : false;
        stateItem.ShowCopyActivitiesButtonInTimesheet = stateItem.ShowCopyActivitiesButtonInTimesheet === true ? true : false;
        stateItem.EnableOfflineTimesheet = stateItem.EnableOfflineTimesheet === true ? true : false;
        stateItem.EnableTimerInTimesheet = stateItem.EnableTimerInTimesheet === true ? true : false;
        stateItem.ShowAllInTimesheetReadOnly = stateItem.ShowAllInTimesheetReadOnly === true ? true : false;
        stateItem.ShowPercentageInTimesheet = stateItem.ShowPercentageInTimesheet === true ? true : false;
        stateItem.CalculateTaskPercentageAutomatically = stateItem.CalculateTaskPercentageAutomatically === true ? true : false;
        stateItem.AutoResizeTimesheet = stateItem.AutoResizeTimesheet === true ? true : false;
        stateItem.EnablePasswordComplexity = stateItem.EnablePasswordComplexity === true ? true : false;
        stateItem.EnableSingleSignOnSSO = stateItem.EnableSingleSignOnSSO === true ? true : false;
        stateItem.ShowFilterInformationOnExport = stateItem.ShowFilterInformationOnExport === true ? true : false;
        // stateItem.AllowZeroHoursInTimesheet = stateItem.AllowZeroHoursInTimesheet === true ? true : false;
        stateItem.AllowZeroHoursInTimesheet = stateItem.AllowZeroHoursInTimesheet === null ? false : (stateItem.AllowZeroHoursInTimesheet === true ? true : false);
        // stateItem.ShowTemplateInTimesheet = stateItem.ShowTemplateInTimesheet === true ? true : false;
        stateItem.ShowTemplateInTimesheet = stateItem.ShowTemplateInTimesheet === null ? false : (stateItem.ShowTemplateInTimesheet === true ? true : false);
        stateItem.EnableAutoClockOut = stateItem.EnableAutoClockOut === null ? false : (stateItem.EnableAutoClockOut === true ? true : false);
        const selectedValue = stateItem.CalendarWeekStartDay;
        const selectedOption = CalendarWeekStartDayOptions.find((option) => option.value === selectedValue);
        if (selectedOption) {
            setSelectedOptionCalendarWeekStartDay(selectedOption);
        }

    }, [selectedRecord])

    const handleSubdomainValidation = (SubDomain: string): boolean => {
        const reg = /^[A-Za-z_-][A-Za-z0-9_-]*$/;
        return reg.test(SubDomain);
    };

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
        if (e.target.name === "AccountName") {
            updatePreferencesErrorList(e.target.name, e.target.value)
        } if (e.target.name === "EMailAddress") {
            updatePreferencesErrorList(e.target.name, e.target.value)
        }
    }






    // const handleCustomChange = (e: any) => {
    //     setScheduledEmailSendTime(e.target.value);
    //     setCurrentFieldsData({ ...currentFieldsData, 'ScheduledEmailSendTime': e.target.value });
    // }

    const handleCustomChange = (time: string | null) => {
        if (time !== null) {
            setScheduledEmailSendTime(time);
            setCurrentFieldsData({ ...currentFieldsData, 'ScheduledEmailSendTime': time });
        }
    }
    const IsSubDomainAvailable = async (value: any) => {
        if (applicationMode === 'Hosted') {
            const tempArray = [...setError.errorMessageList];
            const updatedArray = tempArray.filter((item) => item.name === "SubDomain");
            const tempObj: any = selectedRecord;
            if (value != "") {
                if (tempObj.SubDomain.toLowerCase() !== value.toLowerCase()) {
                    if (handleSubdomainValidation(value)) {
                        const response = await fetchAPI(`api/Employees/IsSubDomainAvailable/` + value, 'Get', '', true);
                        const json = await response.json();
                        if (json[0].Available === 'Yes') {
                            const updatedArray = tempArray.filter((item) => item.name !== "SubDomain");
                            setErrorValues({
                                ...setError,
                                //isError: setError.errorMessageList.length > 0,
                                errorMessageList: updatedArray
                            });
                        }
                        else {
                            // ShowSwal("Error", `${value}.livetecs.com is not available. Domain Already Exist`, 'error');
                            if (updatedArray.length === 0) {
                                tempArray.push({ "name": "SubDomain", "error": `${value}.livetecs.com is not available. Domain Already Exist` });
                            }
                            else if (updatedArray.length > 0) {
                                tempArray.map((item) => {
                                    if (item.name === "SubDomain") {
                                        item.error = `${value}.livetecs.com is not available. Domain Already Exist`
                                    }
                                })
                            }
                            setErrorValues({
                                ...setError,
                                isError: true,
                                errorMessageList: tempArray
                            });
                        }
                    }
                    else {
                        // ShowSwal("Error", `Invalid subdomain! No special characters are allowed.`, 'error');
                        if (updatedArray.length === 0) {
                            tempArray.push({ "name": "SubDomain", "error": `Invalid subdomain! No special characters are allowed.` });
                        }
                        else if (updatedArray.length > 0) {
                            tempArray.map((item) => {
                                if (item.name === "SubDomain") {
                                    item.error = `Invalid subdomain! No special characters are allowed.`
                                }
                            })
                        }
                        setErrorValues({
                            ...setError,
                            isError: true,
                            errorMessageList: tempArray
                        });
                    }
                } else {
                    const updatedArray = tempArray.filter((item) => item.name !== "SubDomain");
                    setErrorValues({
                        ...setError,
                        isError: false,
                        errorMessageList: updatedArray
                    });
                }
            }
            else {
                if (updatedArray.length === 0) {
                    tempArray.push({ "name": "SubDomain", "error": 'Sub domain is required.' });
                }
                else if (updatedArray.length > 0) {
                    tempArray.map((item) => {
                        if (item.name === "SubDomain") {
                            item.error = `Sub domain is required.`
                        }
                    })
                }
                tempArray.length > 0 && setErrorValues({
                    ...setError,
                    isError: true,
                    errorMessageList: tempArray
                });
            }
        }
    }

    const handleChangeDropdown = (data: any, Name: string) => {
        const { value, label } = data;
        if (Name === 'CountryList') {
            setselectedOptionCountry({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'CountryId': value });
        }
        if (Name === 'TimeZoneList') {
            setselectedOptionTimeZone({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'TimeZoneId': value });
        }
        if (Name === 'DecimalList') {
            setSelectedOptionDecimal({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'DecimalPlaces': value });
        }
        if (Name === 'PageSizeList') {
            setSelectedOptionPageSize({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'PageSize': value });
        }
        if (Name === 'StandardFormateList') {
            const formatlabel = getDateFormatPatternByCulture(value);
            const decimalSeplabel = getDecimalSeparator(value);
            setdecimalSeparator(decimalSeplabel);
            setDateFormateLabel(formatlabel);
            setselectedOptionStandardFormat({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'CultureInfoName': value });
        }
        if (Name === 'ShowEmployeeNameList') {
            setSelectedOptionShowEmployeeNameBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ShowEmployeeNameBy': value });
        }
        if (Name === 'EmployeeSegregationTypeList') {
            setSelectedOptionEmployeeSegregationType({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'EmployeeSegregationType': value });
        }

        if (Name === 'BillingTypeList') {
            setselectedOptionBillingType({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'InvoiceBillingTypeId': value });
        }

        if (Name === 'SortTaskByList') {
            setSelectedOptionSortTaskBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'SortTaskBy': value });
        }
        if (Name === 'ShowAdditionalProjectInformationList') {
            setSelectedOptionShowAdditionalProjectInformationType({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ShowAdditionalProjectInformationType': value });
        }
        if (Name === 'ShowTimeOffTypesByOptionsList') {
            setSelectedOptionShowTimeOffTypesBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ShowTimeOffTypesBy': value });
        }
        if (Name === 'ExpenseApprovalTypeByList') {
            setSelectedOptionExpenseApprovalTypeBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ExpenseApprovalTypeBy': value });
        }
        if (Name === 'ShowClockStartEndByList') {
            setSelectedOptionShowClockStartEndBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ShowClockStartEndBy': value });
        }
        if (Name === 'TimeEntryClockFormatList') {
            setSelectedOptionTimeEntryClockFormat({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'TimeEntryFormat': value });
        }
        if (Name === 'ShowAdditionalTaskInformationTypeInTimesheetList') {
            setSelectedOptionShowAdditionalTaskInformationTypeInTimesheet({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ShowAdditionalTaskInformationType': value });
        }
        if (Name === 'DefaultTimeEntryModeList') {
            setSelectedOptionDefaultTimeEntryMode({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'DefaultTimeEntryMode': value });
        }
        if (Name === 'SortTimesheetByList') {
            setSelectedOptionSortTimesheetBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'TimesheetSort': value });
        }
        if (Name === 'ShowCostCenterInTimesheetByList') {
            setSelectedOptionShowCostCenterInTimesheetBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'ShowCostCenterInTimesheetBy': value });
        }
        if (Name === 'TimesheetApprovalTypeByList') {
            setSelectedOptionTimesheetApprovalTypeBy({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'TimesheetApprovalTypeBy': value });
        }
        if (Name === 'TimeEntryHoursFormatList') {
            setselectedOptionTimeEntryHoursFormat({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'TimeEntryHoursFormatId': value });
        }
        if (Name === 'CalendarWeekStartDayList') {
            setSelectedOptionCalendarWeekStartDay({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'CalendarWeekStartDay': value });
        }

        if (Name === 'SingleSignOnSSOOList') {
            setSelectedOptionSingleSignOnSSO({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'UsingSingleSignOnWith': value });
        }
        if (Name === 'ShowAssignHolidayTypeInList') {
            setSelectedOptionAssignHolidayTypeIn({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'AssignHolidayTypeIn': value });
        }
        if (Name === 'ShowAssignWorkingDayTypeInList') {
            setSelectedOptionAssignWorkingDayTypeIn({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'AssignWorkingDayTypeIn': value });
        }
        if (Name === 'ShowAssignTimeOffPolicyInList') {
            setSelectedOptionAssignTimeOffPolicyIn({ value: value, label: label });
            setCurrentFieldsData({ ...currentFieldsData, 'AssignTimeOffPolicyIn': value });
        }


    };

    const handleAudit = () => {
        const obj = {
            Id: sessionAccountId,
            TableName: 'AccountPreferences',
            Title: 'Preferences Audit'
        }
        // navigate('/accountaudit', { state: { obj } });
        navigate(`/accountaudit/${sessionAccountId}`, { state: { obj } });
    }

    function validateEmail(email: any) {
        //const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailPattern.test(email);
    }

    const updatePreferencesErrorList = (fieldName: string, value: any) => {
        const tempArray = [...setError.errorMessageList];
        const updatedArray = tempArray.filter((item) => item.name === fieldName);
        let removeArray;
        let newItem = "";
        if (fieldName === "AccountName") {
            newItem = "Account name is required.";
        } else if (fieldName === "EMailAddress") {
            newItem = "Email address is required.";
        }
        if (updatedArray.length === 0) {
            if (value === "") {
                tempArray.push({ "name": fieldName, "error": newItem });
                tempArray.length > 0 && setErrorValues({
                    ...setError,
                    isError: true,
                    errorMessageList: tempArray,
                });
            }
        }
        else if (updatedArray.length > 0) {
            if (fieldName === "EMailAddress") {
                if (value == "") {
                    tempArray.length > 0 && tempArray.map((item) => {
                        if (item.name === 'EMailAddress') {
                            item.error = newItem;
                        }
                    })
                    setErrorValues({
                        ...setError,
                        errorMessageList: tempArray
                    });
                    return
                }
                else if (!(validateEmail(value))) {
                    tempArray.map((item) => {
                        if (item.name === 'EMailAddress') {
                            item.error = "Please enter a valid email address.";
                        }
                    })
                    setErrorValues({
                        ...setError,
                        errorMessageList: tempArray
                    });
                    return
                } else {
                    removeArray = tempArray.filter((item) => item.name !== fieldName);
                }
            } else {
                removeArray = tempArray.filter((item) => item.name !== fieldName);
            }
            setErrorValues({
                ...setError,
                errorMessageList: removeArray,
                //isError: tempArray.length === 1 ? false : true
            });
            return
        }
        // tempArray.length === 0 && setErrorValues({
        //     ...setError,
        //     isError: tempArray.length === 0 ? false : true
        // });
    }

    const validatePreferences = () => {

        let tempArray: any[] = [];
        if (currentFieldsData.AccountName == "") {
            tempArray.push({ "name": "AccountName", "error": "Account name is required." });
        }
        if (currentFieldsData.EMailAddress == "") {
            tempArray.push({ "name": "EMailAddress", "error": "Email address is required." });
        } else {
            if (!(validateEmail(currentFieldsData.EMailAddress))) {
                tempArray.push({ "name": "EMailAddress", "error": "Please enter a valid email address." });
            }
        }
        if (currentFieldsData.EnableAutoClockOut) {
            const autoClockOutDelayHours = currentFieldsData.AutoClockOutDelayHours ?? 0;
            if (autoClockOutDelayHours <= 0 || autoClockOutDelayHours >= 24) {
                tempArray.push({ "name": "AutoClockOutDelayHours", "error": "Auto Clock-Out Delay Hours must be greater than 0 and less than 24 when Auto Clock-Out is enabled." });
            }
        }
        // if (currentFieldsData.SubDomain == "" && applicationMode === 'Hosted') {
        //     tempArray.push({ "name": "SubDomain", "error": "Sub domain is required." });
        // }
        // if (applicationMode === 'Hosted' && !handleSubdomainValidation(currentFieldsData.SubDomain)) {
        //     tempArray.push({ "name": "SubDomain", "error": "Invalid subdomain! No special characters are allowed." });
        // }
        if (currentFieldsData.SubDomain == "" && applicationMode === 'Hosted') {
            tempArray.push({ "name": "SubDomain", "error": "Sub domain is required." });
        } else if (currentFieldsData.SubDomain != "" && applicationMode === 'Hosted') {
            IsSubDomainAvailable(currentFieldsData.SubDomain)
            if (setError.errorMessageList.length > 0) {
                return;
            }
        }
        if (currentFieldsData.CountryId == "") {
            tempArray.push({ "name": "CountryList", "error": "Country is required." });
        }
        if (tempArray.length > 0) {
            setErrorValues({
                ...setError,
                isError: true,
                errorMessageList: tempArray
            });
        }
        else {
            setErrorValues({
                ...setError,
                isError: false,
                errorMessageList: []
            });
            dispatch(UpdateAccountPreferencesAsync(currentFieldsData))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Preferences Updated Successfully", 'Success', "success", "toast-top-right")
                    dispatch(updatePageSize(selectedOptionPageSize.value));
                    dispatch(updateAllowZeroHoursInTimesheet(currentFieldsData.AllowZeroHoursInTimesheet));
                    dispatch(updateLoadingEffect(true));
                    dispatch(getGlobalAccountPreferenceDataAsync());
                })
                .catch((rejectedValueOrSerializedError) => {

                })
        }
    }

    const handleSubmit = (e: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            validatePreferences();
            // if (currentFieldsData.AccountName == "") {
            //     ShowSwal("Error", `Account name is required.`, 'error');
            //     return;
            // }
            // if (currentFieldsData.EMailAddress == "") {
            //     ShowSwal("Error", `Email address is required.`, 'error');
            //     return;
            // }
            // if (currentFieldsData.SubDomain == "" && applicationMode === 'Hosted') {
            //     ShowSwal("Error", `Sub domain is required.`, 'error');
            //     return;
            // }
            // if (applicationMode === 'Hosted' && !handleSubdomainValidation(currentFieldsData.SubDomain)) {
            //     ShowSwal("Error", `Invalid subdomain! No special characters are allowed.`, 'error');
            //     return;
            // }
            // if (currentFieldsData.CountryId == "") {
            //     ShowSwal("Error", `Country is required.`, 'error');
            //     return;
            // }
            // dispatch(UpdateAccountPreferencesAsync(currentFieldsData))
            //     .unwrap()
            //     .then((originalPromiseResult) => {
            //         ShowToast("Preferences Updated Successfully", 'Success', "success", "toast-top-right")
            //     })
            //     .catch((rejectedValueOrSerializedError) => {
            //     })
        }
    }

    useLayoutEffect(() => {
        dispatch(getCustomPagePermissionsAsync("18, 19, 134, 135, 142")).then((res) => {
            if (res.meta.requestStatus === 'fulfilled') {
                let permissions = res.payload;
                setChilds({
                    ...childs,
                    IsMyTimesheet: getPermission(18, permissions),
                    IsTimeEntryPeriodView: getPermission(19, permissions),
                    IsBilling: getPermission(134, permissions),
                    IsMyExpenses: getPermission(135, permissions),
                    IsMyTimeOff: getPermission(142, permissions),
                });
            }
        }).catch()
    }, []);

    function getPermission(id: any, permissions: any) {
        const permission = permissions.find((x: any) => x.Id === id);
        return permission ? permission.IsList : false; // Default to false if permission is not found
    }

    return (
        <>
            {isLoading && <Loader />}
            <>
                <div className="card">
                    <div className="card-header sticky-top bg-white mb-5 fixed-top">
                        <h3 className="card-title fw-bold headerTitle">
                            {/* {t('Application Preference')} */}
                            {getValueFromResource('Application Preference', dispatch, t)}
                        </h3>
                        <div className="card-toolbar align-items-center">
                            <a id="btnAudit"
                                type="button"
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content=
                                // {t('Audit')}
                                {getValueFromResource('Audit', dispatch, t)}
                                data-tooltip-place="bottom"
                                onClick={() => handleAudit()}>
                                <i className="bi bi-receipt fs-2 iconColor"></i>
                            </a>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            {IsEdit ? (
                                <button type="button" className="btn btn-primary btn-sm" onClick={handleSubmit}>
                                    {/* {t('Update Preference')} */}
                                    {getValueFromResource('Update Preference', dispatch, t)}
                                </button>
                            ) : null}
                        </div>
                        <Tooltip id="tooltip-Description" style={{ fontSize: 12, fontWeight: 600 }} />
                    </div>
                    <ul className='nav nav-stretch nav-line-tabs  border-transparent flex-nowrap mb-4' role='tablist'>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === (t('Organization')) })}
                                onClick={() => setTab(t('Organization'))}
                                role='tab'
                            >
                                {/* {t('Organization')} */}
                                {getValueFromResource('Organization', dispatch, t)}
                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'General' })}
                                onClick={() => setTab('General')}
                                role='tab'
                            >
                                {/* {t('General')} */}
                                {getValueFromResource('General', dispatch, t)}

                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Employee' })}
                                onClick={() => setTab('Employee')}
                                role='tab'
                            >
                                {/* {t('Employee')} */}
                                {getValueFromResource('Employee', dispatch, t)}
                            </a>
                        </li>
                        {childs.IsBilling && <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Invoice' })}
                                onClick={() => setTab('Invoice')}
                                role='tab'
                            >
                                {/* {t('Invoice')} */}
                                {getValueFromResource('Invoice', dispatch, t)}

                            </a>
                        </li>}
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Task' })}
                                onClick={() => setTab('Task')}
                                role='tab'
                            >
                                {/* {t('Task')} */}
                                {getValueFromResource('Task', dispatch, t)}

                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Project' })}
                                onClick={() => setTab('Project')}
                                role='tab'
                            >
                                {/* {t('Project')} */}
                                {getValueFromResource('Project', dispatch, t)}

                            </a>
                        </li>
                        {childs.IsMyTimeOff && <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimeOff' })}
                                onClick={() => setTab('TimeOff')}
                                role='tab'
                            >
                                {/* {t('TimeOff')} */}
                                {getValueFromResource('Time Off', dispatch, t)}

                            </a>
                        </li>}
                        {childs.IsMyExpenses && <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Expense' })}
                                onClick={() => setTab('Expense')}
                                role='tab'
                            >
                                {/* {t('Expense')} */}
                                {getValueFromResource('Expense', dispatch, t)}
                            </a>
                        </li>}
                        {(childs.IsMyTimesheet || childs.IsTimeEntryPeriodView) && <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Timesheet' })}
                                onClick={() => setTab('Timesheet')}
                                role='tab'
                            >
                                {/* {t('Timesheet')} */}
                                {getValueFromResource('Timesheet', dispatch, t)}
                            </a>
                        </li>}
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Security' })}
                                onClick={() => setTab('Security')}
                                role='tab'
                            >
                                {/* {t('Security')} */}
                                {getValueFromResource('Security', dispatch, t)}

                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Report' })}
                                onClick={() => setTab('Report')}
                                role='tab'
                            >
                                {/* {t('Report')} */}
                                {getValueFromResource('Report', dispatch, t)}

                            </a>
                        </li>
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Attendance' })}
                                onClick={() => setTab('Attendance')}
                                role='tab'
                            >
                                {getValueFromResource('Attendance', dispatch, t)}

                            </a>
                        </li>
                    </ul>
                    {setError.isError && <div id="validationerror" className="alert alert-danger">
                        <strong>Error!</strong>
                        <ul>
                            {setError.errorMessageList.length > 0 && setError.errorMessageList.map((item: any, index: number) => (
                                <li key={index}>{item.error}</li>
                            ))}
                        </ul>
                    </div>}
                    <div className='tab-content pt-0' >
                        <div className={clsx('tab-pane', { active: tab === 'Organization' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5 ">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Organization Informations')} */}
                                        {getValueFromResource('Organization Informations', dispatch, t)}

                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Account Name')} */}
                                                {getValueFromResource('Account Name', dispatch, t)}

                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal mb-4" id='AccountName' name="AccountName" value={currentFieldsData.AccountName} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Email Address')} */}
                                                {getValueFromResource('Email Address', dispatch, t)}
                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal mb-4" id='EMailAddress' name="EMailAddress" value={currentFieldsData.EMailAddress} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        {applicationMode === 'Hosted' &&
                                            <div className="col-md-4 col-lg-4 mb-2">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Your TimeLive URL')} */}
                                                    {getValueFromResource('Your TimeLive URL', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-Preferences"
                                                        data-tooltip-content={getValueFromResource("The subdomain you choose will determine the web address at which you and your team will log into your TimeLive account.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>
                                                    {/* <i className="bi bi-info-circle fs-7 cursor-pointer"
                                                        style={{ marginLeft: '10px', whiteSpace: 'pre-line' }}
                                                        data-tooltip-id="tooltip-Preferences"
                                                        data-tooltip-content={t("The subdomain you choose will determine the web address at which you and your team will log into your TimeLive account.")}
                                                        data-tooltip-place="top"
                                                    >
                                                    </i> */}
                                                </label>
                                                <input type="text" className="form-control fs-7 fw-normal mb-4" id='SubDomain' name="SubDomain" value={currentFieldsData.SubDomain} onChange={(e) => handleTextChange(e)} onBlur={(e) => IsSubDomainAvailable(e.target.value)} />
                                            </div>
                                        }
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Country')}  */}
                                                {getValueFromResource('Country', dispatch, t)}

                                            </label>
                                            <Select
                                                value={selectedOptionCountry}
                                                className='fs-7 fw-normal mb-4'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="CountryList"
                                                onChange={(e) => handleChangeDropdown(e, t('CountryList'))}
                                                options={countryArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Time Zone')} */}
                                                {getValueFromResource('Time Zone', dispatch, t)}

                                            </label>
                                            <Select
                                                value={selectedOptionTimeZone}
                                                className='fs-7 fw-normal mb-4'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="TimeZoneList"
                                                onChange={(e) => handleChangeDropdown(e, t('TimeZoneList'))}
                                                options={TimeZoneArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Address1')}  */}
                                                {getValueFromResource('Address1', dispatch, t)}

                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal fs-7 fw-normal mb-4" id='Address1' value={currentFieldsData.Address1} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        {/* </div>
                                    <div className="row mt-4"> */}
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Address2')}  */}
                                                {getValueFromResource('Address2', dispatch, t)}

                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal fs-7 fw-normal mb-4" id='Address2' value={currentFieldsData.Address2} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Zipcode')}  */}
                                                {getValueFromResource('Zip code', dispatch, t)}

                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal fs-7 fw-normal mb-4" id='ZipCode' value={currentFieldsData.ZipCode} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('City')} */}
                                                {getValueFromResource('City', dispatch, t)}

                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal fs-7 fw-normal mb-4" id='City' value={currentFieldsData.City} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        {/* </div>
                                    <div className="row mt-4"> */}
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Telephone')}  */}
                                                {getValueFromResource('Phone', dispatch, t)}

                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal fs-7 fw-normal mb-4" id='Telephone' value={currentFieldsData.Telephone} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Fax')} */}
                                                {getValueFromResource('Fax', dispatch, t)}

                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal fs-7 fw-normal mb-4" id='Fax' value={currentFieldsData.Fax} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.IsEmailSubscription} id="IsEmailSubscription" onChange={(e) => handleTextChange(e)} />

                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Emails Opt-in')} */}
                                                    {getValueFromResource('Emails Opt-in', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-organization"
                                                        data-tooltip-content={getValueFromResource("Allow users to receive system-generated email notifications.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>
                                                </label>
                                                <p className="form-check-label fs-7">  </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'General' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('General Information')}  */}
                                        {getValueFromResource('General Information', dispatch, t)}

                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Scheduled Email Sent Time', dispatch, t)}
                                            </label>
                                            { }
                                            {/* <input type="text" placeholder="00:00" className="form-control fs-7 fw-normal" name='ScheduledEmailSendTime' id='ScheduledEmailSendTime' value={scheduledEmailSendTime} onChange={(e) => handleCustomChange(e)} /> */}

                                            <TimePicker
                                                value={scheduledEmailSendTime}
                                                onChange={handleCustomChange}
                                                clearIcon={null}
                                                format="HH:mm" // 24-hour format
                                                className="form-control fs-7 fw-normal"
                                                name="ScheduledEmailSendTime"
                                                id="ScheduledEmailSendTime"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Session Time Out')} */}
                                                {getValueFromResource('Session Time Out', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Specify how long an inactive user session remains active before automatic sign-out.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal" id='AccountSessionTimeout' value={currentFieldsData.AccountSessionTimeout} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2  d-flex align-items-center gap-1">
                                                {/* {t('Decimal Places')} */}
                                                {getValueFromResource('Decimal Places', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Set the number of decimal places displayed for hours, rates, and calculations throughout the application.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionDecimal}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="decimalList"
                                                onChange={(e) => handleChangeDropdown(e, t('DecimalList'))}
                                                options={options}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2  d-flex align-items-center gap-1">
                                                {/* {t('Page Size')} */}
                                                {getValueFromResource('Page Size', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Select the default number of records displayed per page in lists and grids.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionPageSize}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="PageSizeList"
                                                onChange={(e) => handleChangeDropdown(e, t('PageSizeList'))}
                                                options={PageOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2  d-flex align-items-center gap-1">
                                                {/* {t('Assign Holiday Type In')} */}
                                                {getValueFromResource('Assign Holiday Type In', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether holiday calendars are assigned directly to employees or inherited from their location.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionAssignHolidayTypeIn}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowAssignHolidayTypeInList"
                                                onChange={(e) => handleChangeDropdown(e, t('ShowAssignHolidayTypeInList'))}
                                                options={AssignHolidayTypeInOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2  d-flex align-items-center gap-1">
                                                {/* {t('Assign Working Day Type In')} */}
                                                {getValueFromResource('Assign Working Day Type In', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether working day schedules are assigned at the employee or department level.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionAssignWorkingDayTypeIn}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowAssignWorkingDayTypeInList"
                                                onChange={(e) => handleChangeDropdown(e, t('ShowAssignWorkingDayTypeInList'))}
                                                options={AssignWorkingDayTypeInOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Assign Time Off Policy In')} */}
                                                {getValueFromResource('Assign Time Off Policy In', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether time off policies are assigned directly to employees or through departments.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionAssignTimeOffPolicyIn}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowAssignTimeOffPolicyInList"
                                                onChange={(e) => handleChangeDropdown(e, t('ShowAssignTimeOffPolicyInList'))}
                                                options={AssignTimeOffPolicyInOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('From Email Display Name')} */}
                                                {getValueFromResource('From Email Display Name', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Enter the sender name displayed on system-generated emails.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal" id='FromEmailAddressDisplayName' value={currentFieldsData.FromEmailAddressDisplayName} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('From Email address')} */}
                                                {getValueFromResource('From Email address', dispatch, t)}

                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal" id='FromEmailAddress' value={currentFieldsData.FromEmailAddress} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2  d-flex align-items-center gap-1">
                                                {/* {t('Standard and Formats')} */}
                                                {getValueFromResource('Standard and Formats', dispatch, t)} : Date ({dateFormateLabel})  & Decimal Separator: ( {decimalSeparatorLabel} )
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Configure regional formats for dates, numbers, and decimal separators used throughout the application.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionStandardFormat}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="StandardFormateList"
                                                onChange={(e) => handleChangeDropdown(e, t('StandardFormateList'))}
                                                options={StandardFormatArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Show Employee Name By')} */}
                                                {getValueFromResource('Show Employee Name By', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionShowEmployeeNameBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowEmployeeNameList"
                                                onChange={(e) => handleChangeDropdown(e, t('ShowEmployeeNameList'))}
                                                options={ShowEmployeeNameByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Calendar Week Start Day', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionCalendarWeekStartDay}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="CalendarWeekStartDayList"
                                                onChange={(e) => handleChangeDropdown(e, 'CalendarWeekStartDayList')}
                                                options={CalendarWeekStartDayOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t('Company Own Logo')}  */}
                                            {getValueFromResource('Company Own Logo', dispatch, t)}

                                        </label>
                                        <div {...getRootProps({ className: 'dropzone' })} style={{ display: 'flex', alignItems: 'center' }}>
                                            <input {...getInputProps()} />
                                            <p>
                                                {/* {t('Drag n drop some files here, or click to select files')} */}
                                                {getValueFromResource('Drag n drop some files here, or click to select files', dispatch, t)}

                                                <br></br><b>
                                                    {/* {t('Max File Size is 30MB')} */}
                                                    {getValueFromResource('Max File Size is 30MB', dispatch, t)}

                                                </b></p>
                                            {files[0] && (
                                                <div style={{ marginLeft: '50px' }}>
                                                    {files[0].type.startsWith('image/') ? (
                                                        <img
                                                            src={URL.createObjectURL(files[0])}
                                                            alt={files[0].name}
                                                            style={{ maxWidth: '100%', maxHeight: '100px' }} />
                                                    ) : (
                                                        <p>{files[0].name}</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row mt-4 mb-2">
                                        <div className="col-md-4 col-lg-4 " id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.LockSubmittedRecords} id="LockSubmittedRecords" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Lock Submitted Records')} */}
                                                    {getValueFromResource('Lock Submitted Records', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-organization"
                                                        data-tooltip-content={getValueFromResource("Prevent users from modifying records after they have been submitted.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>

                                                </label>
                                                <p className="form-check-label fs-7">   </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.LockApprovedRecords} id="LockApprovedRecords" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Lock In-Approval/Approved Records')} */}
                                                    {getValueFromResource('Lock In-Approval/Approved Records', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-organization"
                                                        data-tooltip-content={getValueFromResource("Prevent changes to records that are awaiting approval or have already been approved.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>
                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.IsShowElectronicSign} id="IsShowElectronicSign" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Use Electronic Signature')} */}
                                                    {getValueFromResource('Use Electronic Signature', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-organization"
                                                        data-tooltip-content={getValueFromResource("Require users to electronically sign records before submission or approval where applicable.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>

                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row  mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.EnableUploadFeature} id="EnableUploadFeature"
                                                    onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Enable Upload Feature')} */}
                                                    {getValueFromResource('Enable Upload Feature', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-organization"
                                                        data-tooltip-content={getValueFromResource("Allow users to upload attachments to supported records throughout the application.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>

                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row  mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.ShowAdditionalDepartmentInformationInEmployee} id="ShowAdditionalDepartmentInformationInEmployee" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Show Additional Department Information In Employee')} */}
                                                    {getValueFromResource('Show Additional Department Information In Employee', dispatch, t)}
                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className=" pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.IsShowEmployeeNameWithCode} id="IsShowEmployeeNameWithCode" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Show Employee Name With Code')}  */}
                                                    {getValueFromResource('Show Employee Name With Code', dispatch, t)}

                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row  mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.IsShowDisableEmployeesInReport} id="IsShowDisableEmployeesInReport" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Show Disable Employees In Report')} */}
                                                    {getValueFromResource('Show Disable Employees In Report', dispatch, t)}
                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row  mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.RestrictEntryWithinTaskDateRange} id="RestrictEntryWithinTaskDateRange" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Restrict Entry Within Task Date Range')} */}
                                                    {getValueFromResource('Restrict Entry Within Task Date Range', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-organization"
                                                        data-tooltip-content={getValueFromResource("Prevent time or related entries from being recorded outside the task's defined start and end dates.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>

                                                </label>
                                                <p className="form-check-label fs-7">    </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                    <div className="row  mb-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.IsCompanyOwnLogo} id="IsCompanyOwnLogo" onChange={(e) => handleTextChange(e)} />
                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Show Company Own Logo')} */}
                                                    {getValueFromResource('Show Company Own Logo', dispatch, t)}

                                                </label>
                                                <p className="form-check-label fs-7">  </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Employee' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Employee Segregation')}  */}
                                        {getValueFromResource('Employee Segregation', dispatch, t)}
                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3">
                                    <div className="row" style={{ height: '500px' }}>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Employee Segregation Type')} */}
                                                {getValueFromResource('Employee Segregation Type', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Control how employees are separated within the application, such as by Department or Location, for visibility on employee list.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionEmployeeSegregationType}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="EmployeeSegregationTypeList"
                                                onChange={(e) => handleChangeDropdown(e, t('EmployeeSegregationTypeList'))}
                                                options={EmployeeSegregationTypeOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Invoice' })}>
                            <div className="card card-custom" >
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Invoice Information')} */}
                                        {getValueFromResource('Invoice Information', dispatch, t)}
                                    </h3>
                                </div>
                                {/* <div className="card-body flow p-0 p-3"> */}
                                <div className="card-Report-body flow p-0 p-3">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Invoice No Prefix')} */}
                                                {getValueFromResource('Invoice No Prefix', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Enter a prefix that will be added to all generated invoice numbers.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal" id='InvoiceNoPrefix' value={currentFieldsData.InvoiceNoPrefix} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Invoice Billing Type')} */}
                                                {getValueFromResource('Invoice Billing Type', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether invoices calculate billable work using hours or days.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionBillingType}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="BillingTypeList"
                                                onChange={(e) => handleChangeDropdown(e, 'BillingTypeList')}
                                                options={BillingTypeArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>

                                    </div>

                                    <div className="row mt-4 mb-2">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Invoice Footer')} */}
                                                {getValueFromResource('Invoice Footer', dispatch, t)}
                                            </label>
                                            <textarea
                                                rows={4}
                                                cols={50}
                                                placeholder=
                                                // {t('Enter your text here...')}
                                                {getValueFromResource('Enter your text here...', dispatch, t)}
                                                id='InvoiceFooter' value={currentFieldsData.InvoiceFooter} onChange={(e) => handleTextChange(e)}
                                                className="form-control fs-7 fw-normal" />
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <hr className="pt-1 pb-1 mt-1 mb-1" />
                                        <div className="row">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowProjectNameInInvoiceReport} id="ShowProjectNameInInvoiceReport" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Project Name In Invoice Report')} */}
                                                        {getValueFromResource('Show Project Name In Invoice Print', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7"> </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row my-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowBillingRateInInvoiceReport} id="ShowBillingRateInInvoiceReport" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Billing Rate In Invoice Report')} */}
                                                        {getValueFromResource('Show Billing Rate In Invoice Print', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowEntryDateInInvoiceReport} id="ShowEntryDateInInvoiceReport" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Entry Date In Invoice Report')} */}
                                                        {getValueFromResource('Show Entry Date In Invoice Print', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7"> </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowEmployeeNameInInvoiceReport} id="ShowEmployeeNameInInvoiceReport" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Employee Name In Invoice Report')} */}
                                                        {getValueFromResource('Show Employee Name In Invoice Print', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowWorkTypeInInvoiceDescription} id="ShowWorkTypeInInvoiceDescription" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Work Type In Invoice Description')} */}
                                                        {getValueFromResource('Show Work Type In Invoice Description', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">    </p>
                                                </div>
                                            </div>
                                        </div>


                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.RoundOffValueInInvoice} id="RoundOffValueInInvoice" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Round-Off Value In Invoice')} */}
                                                        {getValueFromResource('Round-Off Value In Invoice', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7"> </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ResetInvoiceNo} id="ResetInvoiceNo" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Reset Invoice No')} */}
                                                        {getValueFromResource('Reset Invoice No', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Automatically restart invoice numbering based on your configured numbering rules.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">    </p>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Task' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Task Information')} */}
                                        {getValueFromResource('Task Information', dispatch, t)}
                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3 flow"> */}
                                <div className="card-Report-body p-0 p-3 flow">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 form-label fs-7 fw-normal mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Sort Task By')} */}
                                                {getValueFromResource('Sort Task By', dispatch, t)}

                                            </label>
                                            <Select
                                                value={selectedOptionSortTaskBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="SortTaskByList"
                                                onChange={(e) => handleChangeDropdown(e, t('SortTaskByList'))}
                                                options={SortTaskByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        <hr className="pt-1 pb-1 mt-1 mb-1" />
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowProjectNameInTask} id="ShowProjectNameInTask" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Project Name In Task')} */}
                                                        {getValueFromResource('Show Project Name In Task', dispatch, t)}

                                                    </label>
                                                    <p className="form-check-label fs-7">    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowClientNameInTask} id="ShowClientNameInTask" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Client Name In Task')} */}
                                                        {getValueFromResource('Show Client Name In Task', dispatch, t)}

                                                    </label>
                                                    <p className="form-check-label fs-7">    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsAutoCompleteTask} id="IsAutoCompleteTask" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Auto Complete Task')} */}
                                                        {getValueFromResource('Auto Complete Task', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Automatically mark tasks as completed when they reach the configured completion criteria.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>

                                                    </label>
                                                    <p className="form-check-label fs-7">   </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.AllocationHoursInProjectTaskTeam} id="AllocationHoursInProjectTaskTeam" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Resources Allocation Hours')} */}
                                                        {getValueFromResource('Resources Allocation Hours', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Enable planned resource allocation hours for task scheduling and capacity planning.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>

                                                    </label>
                                                    <p className="form-check-label fs-7">   </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Project' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Project Information')} */}
                                        {getValueFromResource('Project Information', dispatch, t)}

                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Project Code Prefix')} */}
                                                {getValueFromResource('Project Code Prefix', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Enter a prefix that will be added to automatically generated project codes.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>

                                            </label>
                                            <input type="text" className="form-control fs-7 fw-normal" id='ProjectCodePrefix' value={currentFieldsData.ProjectCodePrefix} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        {/* <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Show Additional Project Information Type', dispatch, t)}

                                            </label>
                                            <Select
                                                value={selectedOptionShowAdditionalProjectInformationType}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowAdditionalProjectInformationList"
                                                onChange={(e) => handleChangeDropdown(e, 'ShowAdditionalProjectInformationList')}
                                                options={ShowAdditionalProjectInformationTypeOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div> */}
                                    </div>
                                    <div className="row my-2">
                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.AutoGenerateProjectCode} id="AutoGenerateProjectCode" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Auto Generate Project Code')} */}
                                                        {getValueFromResource('Auto Generate Project Code', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Automatically assign a unique project code when creating new projects.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>

                                                    </label>
                                                    <p className="form-check-label fs-7">   </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.AllocationHoursInProjectTeam} id="AllocationHoursInProjectTeam" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Resources Allocation Hours')} */}
                                                        {getValueFromResource('Resources Allocation Hours', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Enable planned resource allocation hours for project resource planning.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        {/* <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.EnableGanttChart} id="EnableGanttChart" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                    
                                                        {getValueFromResource('Enable Gantt Chart', dispatch, t)}

                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowCompletedProjectInProjectGrid} id="ShowCompletedProjectInProjectGrid" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Completed Project In Project List')} */}
                                                        {getValueFromResource('Show Completed Project In Project List', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowClientDepartmentInProject} id="ShowClientDepartmentInProject" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Client Department In Project')} */}
                                                        {getValueFromResource('Show Client Department In Project', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IncludeCurrentYearInProjectCode} id="IncludeCurrentYearInProjectCode" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Include Current Year In Project Code')} */}
                                                        {getValueFromResource('Include Current Year In Project Code', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2  h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.AutomaticallyIncludeAdminitratorInProjectTeam} id="AutomaticallyIncludeAdminitratorInProjectTeam" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Automatically Include Administrator In Project Team')} */}
                                                        {getValueFromResource('Automatically Include Administrator In Project Team', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Automatically add system administrators as members of every newly created project.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowDisableProjectInReport} id="ShowDisableProjectInReport" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Disable Project In Report')} */}
                                                        {getValueFromResource('Show Disable Project In Report', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsProjectTemplateMandatory} id="IsProjectTemplateMandatory" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Project Template Mandatory')} */}
                                                        {getValueFromResource('Project Template Mandatory', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'TimeOff' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Time Off Information')} */}
                                        {getValueFromResource('Time Off Information', dispatch, t)}
                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Show TimeOff Types By')} */}
                                                {getValueFromResource('Show Time Off Types By', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether available time off types are determined by the account or each employee's assigned policy.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionShowTimeOffTypesBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowTimeOffTypesByOptionsList"
                                                onChange={(e) => handleChangeDropdown(e, 'ShowTimeOffTypesByOptionsList')}
                                                options={ShowTimeOffTypesByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowTimeOffInTimesheet} id="ShowTimeOffInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show TimeOff in Timesheet')} */}
                                                        {getValueFromResource('Show Time Off in Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowProjectForTimeOff} id="ShowProjectForTimeOff" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Project For TimeOff')} */}
                                                        {getValueFromResource('Show Project For Time Off', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.HideTimeOffHoursInformation} id="HideTimeOffHoursInformation" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Hide TimeOff Hours Information')} */}
                                                        {getValueFromResource('Hide Time Off Hours Information', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>


                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsShowTimeOffInDays} id="IsShowTimeOffInDays" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Show Time Off In Days')} */}
                                                        {getValueFromResource('Show Time Off In Days', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Display time off balances and requests in days instead of hours.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>

                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsShowTimeOffPoliciesInDays} id="IsShowTimeOffPoliciesInDays" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Show Time Off Policies In Days')} */}
                                                        {getValueFromResource('Show Time Off Policies In Days', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Display policy entitlements and accruals in days instead of hours.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>

                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsTimeOffStatusEditMode} id="IsTimeOffStatusEditMode" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row ">
                                                    <label className="form-label fs-7 fw-normal d-flex align-items-center gap-1">
                                                        {/* {t('TimeOff Status Edit Mode')} */}
                                                        {getValueFromResource('Time Off Status Edit Mode', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Control whether admin user to edit assigned time off policy from employee grid.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsShowConsumedHours} id="IsShowConsumedHours" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row ">
                                                    <label className="form-label fs-7 fw-normal d-flex align-items-center gap-1">
                                                        {getValueFromResource(`Show Consumed Hours/Days In TimeOff`, dispatch, t)}
                                                        {/* <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Control whether admin user to edit assigned time off policy from employee grid.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div> */}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Expense' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Expense Information')} */}
                                        {getValueFromResource('Expense Information', dispatch, t)}
                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-3 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Expense Approval Type By')} */}
                                                {getValueFromResource('Expense Approval Type By', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether expense approval workflows are determined by the employee or the project.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionExpenseApprovalTypeBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ExpenseApprovalTypeByList"
                                                onChange={(e) => handleChangeDropdown(e, 'ExpenseApprovalTypeByList')}
                                                options={ExpenseApprovalTypeByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-4 col-lg-5 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Expense Sheet Print Footer')} */}
                                                {getValueFromResource('Expense Sheet Print Footer', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Enter custom text that appears at the bottom of printed expense sheets.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <textarea
                                                rows={8} // Set the number of visible rows
                                                cols={50} // Set the number of visible columns
                                                placeholder=
                                                // "Enter your text here..."
                                                {getValueFromResource('Enter your text here...', dispatch, t)}
                                                id='ExpenseSheetPrintFooter' value={currentFieldsData.ExpenseSheetPrintFooter} onChange={(e) => handleTextChange(e)}
                                                className="form-control fs-7 fw-normal" />

                                        </div>

                                    </div>
                                    <div className="row my-2">
                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowClientInExpenseSheet} id="ShowClientInExpenseSheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Client In Expense Sheet')} */}
                                                        {getValueFromResource('Show Client In Expense Sheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowTaskInExpenseSheet} id="ShowTaskInExpenseSheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Task in Expense Sheet')} */}
                                                        {getValueFromResource('Show Task in Expense Sheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Timesheet' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Timesheet Information')}  */}
                                        {getValueFromResource('Timesheet Information', dispatch, t)}
                                    </h3>
                                </div>
                                {/* <div className="card-body flow p-0 p-3"> */}
                                <div className="card-Report-body p-0 p-3 flow">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Number Of Blank Rows in Timesheet')} */}
                                                {getValueFromResource('Number Of Blank Rows in Timesheet', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Specify how many empty rows are displayed when users open a new timesheet for faster data entry.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal" id='NumberOfBlankRowsInTimeEntry' value={currentFieldsData.NumberOfBlankRowsInTimeEntry} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                        {/* <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                              
                                                {getValueFromResource('Number Of Blank Rows In Time Off', dispatch, t)}
                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal" id='NumberOfBlankRowsInTimeOff' value={currentFieldsData.NumberOfBlankRowsInTimeOff} onChange={(e) => handleTextChange(e)} />
                                        </div> */}
                                        <div className="col-md-4 col-lg-4 mb-2" id="divCheckBox">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Timesheet Periods Overdue')} */}
                                                {getValueFromResource('Timesheet Periods Overdue', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Defines the period used to indicate how long a timesheet has been overdue in overdue notification emails.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal" id='TimesheetOverduePeriods' value={currentFieldsData.TimesheetOverduePeriods} onChange={(e) => handleTextChange(e)} />
                                        </div>

                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Show Clock Start/End By')} */}
                                                {getValueFromResource('Show Clock Start/End By', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Choose whether clock in/out functionality is controlled at the account or working day level.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionShowClockStartEndBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowClockStartEndByList"
                                                onChange={(e) => handleChangeDropdown(e, 'ShowClockStartEndByList')}
                                                options={ShowClockStartEndByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>

                                    </div>

                                    <div className="row mt-4">

                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Time Entry Hours Format')} */}
                                                {getValueFromResource('Time Entry Hours Format', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Display entered time using either standard time (HH:MM) or decimal hours.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionTimeEntryHoursFormat}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="TimeEntryHoursFormatList"
                                                onChange={(e) => handleChangeDropdown(e, 'TimeEntryHoursFormatList')}
                                                options={TimeEntryHoursFormatArray}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Time Entry Clock Format')} */}
                                                {getValueFromResource('Time Entry Clock Format', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionTimeEntryClockFormat}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="TimeEntryClockFormatList"
                                                onChange={(e) => handleChangeDropdown(e, 'TimeEntryClockFormatList')}
                                                options={TimeEntryClockFormatOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>

                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Show Additional Task Information Type')} */}
                                                {getValueFromResource('Show Additional Task Information Type', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionShowAdditionalTaskInformationTypeInTimesheet}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowAdditionalTaskInformationTypeInTimesheetList"
                                                onChange={(e) => handleChangeDropdown(e, 'ShowAdditionalTaskInformationTypeInTimesheetList')}
                                                options={ShowAdditionalTaskInformationTypeInTimesheetOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4">

                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                {/* {t('Default Time Entry Mode')} */}
                                                {getValueFromResource('Default Time Entry Mode', dispatch, t)}
                                                <div
                                                    style={{ marginBottom: "2px" }}
                                                    data-tooltip-id="tooltip-organization"
                                                    data-tooltip-content={getValueFromResource("Select the default layout used when users open the timesheet entry screen.", dispatch, t)}
                                                >
                                                    <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                </div>
                                            </label>
                                            <Select
                                                value={selectedOptionDefaultTimeEntryMode}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="DefaultTimeEntryModeList"
                                                onChange={(e) => handleChangeDropdown(e, 'DefaultTimeEntryModeList')}
                                                options={DefaultTimeEntryModeOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Sort Timesheet By')} */}
                                                {getValueFromResource('Sort Timesheet By', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionSortTimesheetBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="SortTimesheetByList"
                                                onChange={(e) => handleChangeDropdown(e, 'SortTimesheetByList')}
                                                options={SortTimesheetByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>

                                        <div className="col-md-4 col-lg-4">
                                            <label className="form-label fs-7 fw-normal mb-2">

                                                {getValueFromResource('Show Cost Center In Timesheet By', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionShowCostCenterInTimesheetBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowCostCenterInTimesheetByList"
                                                onChange={(e) => handleChangeDropdown(e, 'ShowCostCenterInTimesheetByList')}
                                                options={ShowCostCenterInTimesheetByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Show Additional Project Information Type')} */}
                                                {getValueFromResource('Show Additional Project Information Type', dispatch, t)}

                                            </label>
                                            <Select
                                                value={selectedOptionShowAdditionalProjectInformationType}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="ShowAdditionalProjectInformationList"
                                                onChange={(e) => handleChangeDropdown(e, 'ShowAdditionalProjectInformationList')}
                                                options={ShowAdditionalProjectInformationTypeOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Timesheet Approval Type By')} */}
                                                {getValueFromResource('Timesheet Approval Type By', dispatch, t)}
                                            </label>
                                            <Select
                                                value={selectedOptionTimesheetApprovalTypeBy}
                                                className='fs-7 fw-normal'
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                name="TimesheetApprovalTypeByList"
                                                onChange={(e) => handleChangeDropdown(e, 'TimesheetApprovalTypeByList')}
                                                options={TimesheetApprovalTypeByOptions}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Timesheet Print Footer')} */}
                                                {getValueFromResource('Timesheet Print Footer', dispatch, t)}
                                            </label>
                                            <textarea
                                                rows={9} // Set the number of visible rows
                                                cols={50} // Set the number of visible columns
                                                id='TimesheetPrintFooter' value={currentFieldsData.TimesheetPrintFooter} onChange={(e) => handleTextChange(e)}
                                                className="form-control fs-7 fw-normal" />
                                            {/* <input style={{width: '100%', height: '140px'}} type="text"  className="form-control fs-7 fw-normal" id='TimesheetPrintFooter' value={currentFieldsData.TimesheetPrintFooter} /> */}
                                        </div>

                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Timesheet Submission Message')} */}
                                                {getValueFromResource('Timesheet Submission Message', dispatch, t)}
                                            </label>
                                            <textarea
                                                rows={9} // Set the number of visible rows
                                                cols={50} //Set the number of visible columns
                                                placeholder=
                                                // ={t('Enter your text here...')}
                                                {getValueFromResource('Enter your text here...', dispatch, t)}
                                                id='TimesheetSubmissionMessage' value={currentFieldsData.TimesheetSubmissionMessage} onChange={(e) => handleTextChange(e)}
                                                className="form-control fs-7 fw-normal" />
                                            {/* <input style={{width: '100%', height: '140px'}} type="text" className="form-control fs-7 fw-normal" id='TimesheetSubmissionMessage' value={currentFieldsData.TimesheetSubmissionMessage} /> */}
                                        </div>
                                    </div>
                                    <div className="row my-2">
                                        <hr className="pt-1 pb-1 mt-1 mb-1" />
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowClockStartEnd} id="ShowClockStartEnd" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Clock Start/End')} */}
                                                        {getValueFromResource('Show Clock Start/End', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7"> </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowClientInTimesheet} id="ShowClientInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Client in Timesheet')}  */}
                                                        {getValueFromResource('Show Client in Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsAllowOverlappingTimeEntries} id="IsAllowOverlappingTimeEntries" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Allow Overlapping Time Entries')} */}
                                                        {getValueFromResource('Allow Overlapping Time Entries', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Allow multiple time entries with overlapping time ranges for the same day.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowDescriptionInWeekView} id="ShowDescriptionInWeekView" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Show Description in Week View')} */}
                                                        {getValueFromResource('Show Description in Week View', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Display time entry descriptions input field when doing a time entry.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsTimeEntryDescriptionRequired} id="IsTimeEntryDescriptionRequired" onChange={(e) => handleTextChange(e)} />
                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Time Entry Description Required')} */}
                                                        {getValueFromResource('Time Entry Description Required', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Require users to enter a description before saving a time entry.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowCompletedProjectsInTimeSheet} id="ShowCompletedProjectsInTimeSheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Completed Project in Timesheet')} */}
                                                        {getValueFromResource('Show Completed Project in Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowCompletedTasksInTimeSheet} id="ShowCompletedTasksInTimeSheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Completed Task in TimeSheet')} */}
                                                        {getValueFromResource('Show Completed Task in Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowWorkTypeInTimeSheet} id="ShowWorkTypeInTimeSheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Work Type in TimeSheet')}  */}
                                                        {getValueFromResource('Show Work Type in Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>


                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowCostCenterInTimeSheet} id="ShowCostCenterInTimeSheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Cost Center in TimeSheet')} */}
                                                        {getValueFromResource('Show Cost Center in Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowCopyTimesheetButton} id="ShowCopyTimesheetButton" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Copy Timesheet Button')} */}
                                                        {getValueFromResource('Show Copy Timesheet Button', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowCopyActivitiesButtonInTimesheet} id="ShowCopyActivitiesButtonInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Copy Activities Button In Timesheet')} */}
                                                        {getValueFromResource('Show Copy Activities Button In Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.EnableOfflineTimesheet} id="EnableOfflineTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Enable Offline Timesheet')}  */}
                                                        {/* {getValueFromResource('Enable Offline Timesheet', dispatch, t)} */}
                                                         {getValueFromResource('Enable Timesheets Upload', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Enables users to upload timesheets in CSV format.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>

                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.EnableTimerInTimesheet} id="EnableTimerInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Enable Timer in Timesheet')}  */}
                                                        {getValueFromResource('Enable Timer in Timesheet', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Enable a built-in timer for tracking work duration directly from the timesheet.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowAllInTimesheetReadOnly} id="ShowAllInTimesheetReadOnly" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Show ShowAll in Approval Popup')} */}
                                                        {/* {getValueFromResource('Show ShowAll in Approval Popup', dispatch, t)} */}
                                                        {getValueFromResource('Display ShowAll in Approval Popup', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Display a Show All option in approval screens to allow reviewers to view all applicable records.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2" style={{ display: 'none' }}>
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowPercentageInTimesheet} id="ShowPercentageInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Task Percentage In Timesheet')} */}
                                                        {getValueFromResource('Show Task Percentage In Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.CalculateTaskPercentageAutomatically} id="CalculateTaskPercentageAutomatically" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Calculate Task Percentage Automatically')}  */}
                                                        {getValueFromResource('Calculate Task Percentage Automatically', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Automatically update task completion percentages based on Timesheet hours.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>
                                        {(sessionAccountId === 6455 || sessionAccountId === 12226 || sessionAccountId === 8890 || sessionAccountId === 12184 || sessionAccountId === 9224) &&
                                            <>
                                                {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                                <div className="row mb-2">
                                                    <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                            <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                                type="checkbox" checked={currentFieldsData.DefaultProjectTaskSelectionInTimesheet} id="DefaultProjectTaskSelectionInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                        </div>
                                                        <div className="">
                                                            <label className="form-label fs-7 fw-normal mb-2">
                                                                {/* {t('Default Project/Task Selection In Timesheet')}  */}
                                                                {getValueFromResource('Default Project/Task Selection In Timesheet', dispatch, t)}
                                                            </label>
                                                            <p className="form-check-label fs-7">  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.AutoResizeTimesheet} id="AutoResizeTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Auto Adjust Timesheet')}  */}
                                                        {getValueFromResource('Auto Adjust Timesheet', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Automatically adjust time entries to comply with configured timesheet rules and expected hours.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.AllowZeroHoursInTimesheet} id="AllowZeroHoursInTimesheet" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {/* {t('Allow Zero Hours In Timesheet')}  */}
                                                        {getValueFromResource('Allow Zero Hours In Timesheet', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Allow time entries with zero recorded hours when additional information or placeholders are required.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7">  </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.ShowTemplateInTimesheet} id="ShowTemplateInTimesheet" onChange={(e) => handleTextChange(e)} />
                                                </div>
                                                <div className="">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Show Template In Timesheet')} */}
                                                        {getValueFromResource('Show Template In Timesheet', dispatch, t)}
                                                    </label>
                                                    <p className="form-check-label fs-7"></p>
                                                </div>
                                            </div>
                                        </div>
                                          <div className="row">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsTimesheetApprovalReasonMandatory} id="IsTimesheetApprovalReasonMandatory" onChange={(e) => handleTextChange(e)} />
                                                </div>
                                                <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                   
                                                        {getValueFromResource('Timesheet Approval Reason Mandatory', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Require the approver to enter a reason when approving or rejecting a timesheet.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7"></p>
                                                </div>
                                            </div>
                                        </div>
                                          <div className="row">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.IsTimesheetChangelogEnabled} id="IsTimesheetChangelogEnabled" onChange={(e) => handleTextChange(e)} />
                                                </div>
                                                <div className="">
                                                   <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                        {getValueFromResource('Enable Timesheet Changelog', dispatch, t)}
                                                         <div
                                                            style={{ marginBottom: "0px" }}
                                                            data-tooltip-id="tooltip-organization"
                                                            data-tooltip-content={getValueFromResource("Require users to provide a reason when changing timesheet hours. Changes and reasons are recorded in the Timesheet Audit Trail.", dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <p className="form-check-label fs-7"></p>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Security' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1">
                                        {/* {t('Authentication Information')} */}
                                        {getValueFromResource('Authentication Information', dispatch, t)}
                                        <div
                                            style={{ marginBottom: "2px" }}
                                            data-tooltip-id="tooltip-organization"
                                            data-tooltip-content={getValueFromResource("Configure authentication settings, login methods, and security options used to control user access to the application.", dispatch, t)}
                                        >
                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                        </div>
                                    </h3>
                                </div>
                                {/* <div className="card-body p-0 p-3 flow"> */}
                                <div className="card-Report-body p-0 p-3 flow">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Password Expiry Period')} */}
                                                {getValueFromResource('Password Expiry Period', dispatch, t)}
                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal mb-2" id='PasswordExpiryPeriod' value={currentFieldsData.PasswordExpiryPeriod} onChange={(e) => handleTextChange(e)} />{t('Days (0 = No Expiry)')}
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        {applicationMode === 'Hosted' &&
                                            <>
                                                <hr className="pt-1 pb-1 mt-1 mb-1" />
                                                <div className="row mb-2">
                                                    <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                            <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                                type="checkbox" checked={currentFieldsData.EnableGoogleAuthentication} id="EnableGoogleAuthentication" onChange={(e) => handleTextChange(e)} />

                                                        </div>
                                                        <div className="">
                                                            <label className="form-label fs-7 fw-normal mb-2">
                                                                {/* {t('Enable Password Complexity Enable Google Apps Authentication')} */}
                                                                {/* {getValueFromResource('Enable Password Complexity Enable Google Apps Authentication', dispatch, t)} */}
                                                                {getValueFromResource('Enable Google Apps Authentication', dispatch, t)}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.EnablePasswordComplexity} id="EnablePasswordComplexity" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Enable Password Complexity')} */}
                                                        {getValueFromResource('Enable Password Complexity', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <hr className="pt-1 pb-1 mt-1 mb-1" /> */}
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                    <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                        type="checkbox" checked={currentFieldsData.EnableSingleSignOnSSO} id="EnableSingleSignOnSSO" onChange={(e) => handleTextChange(e)} />

                                                </div>
                                                <div className="row">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Enable Single sign-on SSO')} */}
                                                        {getValueFromResource('Enable Single Sign-On (SSO)', dispatch, t)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    {currentFieldsData.EnableSingleSignOnSSO ? (
                                        <>
                                            <div className="row mt-2">
                                                <div className="col-md-4 col-lg-4" id="divSingle Sign-On">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Sign in using Single Sign-On (SSO) with')} */}
                                                        {getValueFromResource('Sign in using Single Sign-On (SSO) with', dispatch, t)}
                                                    </label>
                                                    <Select
                                                        value={selectedOptionSingleSignOnSSO}
                                                        className='fs-7 fw-normal'
                                                        classNamePrefix="select"
                                                        isSearchable={true}
                                                        name="SingleSignOnSSOOList"
                                                        onChange={(e) => handleChangeDropdown(e, 'SingleSignOnSSOOList')}
                                                        options={SingleSignOnSSOOptions}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                    />
                                                </div>
                                                <div className="col-md-4 col-lg-4">
                                                    <i className="bi bi-info-circle fs-7 cursor-pointer"
                                                        style={{ marginRight: '10px', whiteSpace: 'pre-line' }}

                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {t('This is the URL that TimeLive will invoke to redirect users to your identity provider.')}
                                                        {getValueFromResource('This is the URL that TimeLive will invoke to redirect users to your identity provider.', dispatch, t)} data-tooltip-place="bottom"
                                                    >
                                                    </i>
                                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                                        {/* {t('SAML SSO URL')} */}
                                                        {getValueFromResource('SAML SSO URL', dispatch, t)}
                                                    </label>
                                                    <input type="text" className="form-control fs-7 fw-normal" id='SAMLSSOURL' value={currentFieldsData.SAMLSSOURL} onChange={(e) => handleTextChange(e)} />
                                                </div>
                                                <div className="col-md-4 col-lg-4">
                                                    <i className="bi bi-info-circle fs-7 cursor-pointer"
                                                        style={{ marginRight: '10px', whiteSpace: 'pre-line' }}

                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // {t('This is the URL that TimeLive will redirect yours users to after they sign out.')}
                                                        {getValueFromResource('This is the URL that TimeLive will redirect yours users to after they sign out.', dispatch, t)} data-tooltip-place="bottom"
                                                    >
                                                    </i>
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('Logout URL')}  */}
                                                        {getValueFromResource('Logout URL', dispatch, t)}
                                                    </label>
                                                    <input type="text" className="form-control fs-7 fw-normal" id='RemoteLogoutURL' value={currentFieldsData.RemoteLogoutURL} onChange={(e) => handleTextChange(e)} />
                                                </div>

                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-md-4 col-lg-4">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t('X.509 Certificate')} */}
                                                        {getValueFromResource('X.509 Certificate', dispatch, t)}
                                                    </label>
                                                    <textarea
                                                        rows={4} // Set the number of visible rows
                                                        cols={50} // Set the number of visible columns
                                                        placeholder=
                                                        // "Enter your text here..."
                                                        {getValueFromResource('Enter your text here...', dispatch, t)} id='X509Certificate' value={currentFieldsData.X509Certificate} onChange={(e) => handleTextChange(e)}
                                                        className="form-control fs-7 fw-normal" />

                                                </div>


                                            </div>
                                        </>
                                    ) : null}

                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Report' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle">
                                        {/* {t('Report Information')}  */}
                                        {getValueFromResource('Report Information', dispatch, t)}                                        </h3>
                                </div>
                                <div className="c p-0 p-3">
                                    <div className="row">

                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.ShowFilterInformationOnExport} id="ShowFilterInformationOnExport" onChange={(e) => handleTextChange(e)} />

                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Show Filter Information On Export')} */}
                                                    {getValueFromResource('Show Filter Information On Export', dispatch, t)}
                                                </label>
                                                <p className="form-check-label fs-7">  </p>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Attendance' })}>
                            <div className="card card-custom">
                                <div className="card-header p-0 mb-5">
                                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1">
                                        {getValueFromResource('Attendance Information', dispatch, t)}
                                        {/* <div
                                            style={{ marginBottom: "2px" }}
                                            data-tooltip-id="tooltip-organization"
                                            data-tooltip-content={getValueFromResource("Attendance Information.", dispatch, t)}
                                        >
                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                        </div> */}
                                    </h3>
                                </div>
                                <div className="card-Report-body p-0 p-3 flow">
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 mb-2">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {getValueFromResource('Auto Clock-Out Delay (Hours)', dispatch, t)}
                                            </label>
                                            <input type="number" className="form-control fs-7 fw-normal mb-2" id='AutoClockOutDelayHours' name="AutoClockOutDelayHours" value={currentFieldsData.AutoClockOutDelayHours} onChange={(e) => handleTextChange(e)} />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-4 col-lg-4" id="divCheckBox" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <div className="form-check form-switch form-check-custom" style={{ marginRight: '10px' }}>
                                                <input className="form-check-input custom-padding-right mb-2 h-15px w-30px"
                                                    type="checkbox" checked={currentFieldsData.EnableAutoClockOut} id="EnableAutoClockOut" onChange={(e) => handleTextChange(e)} />

                                            </div>
                                            <div className="">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {getValueFromResource('Enable Auto Clock-Out', dispatch, t)}
                                                </label>
                                                <p className="form-check-label fs-7">  </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Tooltip id="tooltip-Preferences" style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif', width: 200 }} />
                <ReactTooltip
                    id="tooltip-organization"
                    style={TOOLTIP_STYLE}
                    place="top"
                    delayShow={100}
                    delayHide={100}
                    clickable
                    render={({ content }) => {
                        const isLongContent = content && content?.length > 90;
                        return (
                            <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                                {content}
                            </div>
                        );
                    }}
                />
                {/* <ReactTooltip
                    id="tooltip-organization"
                    style={TOOLTIP_STYLE}
                    place="top"
                    delayShow={100}
                    delayHide={100}
                    clickable
                    afterShow={() => {
                        const tooltip = document.querySelector('.react-tooltip') as HTMLElement | null;
                        if (!tooltip) return;
                        const lineHeight = parseFloat(getComputedStyle(tooltip).lineHeight);
                        const lines = tooltip.clientHeight / lineHeight;
                        tooltip.style.maxWidth = lines > 3 ? '380px' : '220px';
                    }}
                /> */}
            </>
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default AccountPreference; 